export default class LocationService {
    constructor($rootScope, $http, $q, $window) {
        this.$http = $http;
        this.$q = $q;
        this.$window = $window;

        this.locationConfig = $rootScope.config.location;

        this.result = {
            "geo": undefined,
            "reversegeo": undefined,
            "lat": undefined,
            "lon": undefined
        }
    }

    /**
     * Get Client info from IP
     * @return promise with json result
     */
    getGeoLocation() {
        var url = this.locationConfig.geoLocationApiUrl;
        return this.$http.get(url);
    }

    /**
     * Get Client location from lat/lon
     * @return promise with json result
     */
    getReverseGeoLocation(lat, lon, lang) {
        if (typeof lang == 'undefined') {
            lang = this.locationConfig.lang;
        }
        var url = this.locationConfig.reverseGeolocationApiUrl + '?location=' + lon + '%2C+' + lat + '&langCode=' + lang + '&outSR=&forStorage=false&f=pjson';
        return this.$http.get(url);
    };

    /**
     * Get Client browser latlon
     * @return promise
     */
    getCurrentPosition() {
        var deferred = this.$q.defer();

        if (!this.$window.navigator.geolocation) {
            deferred.reject('Geolocation in browser is not supported or refused.');
        } else {
            this.$window.navigator.geolocation.getCurrentPosition(
                function (position) {
                    deferred.resolve(position);
                },
                function (err) {
                    deferred.reject(err);
                });
        }
        return deferred.promise;
    };

    /**
     * return Promise which tries to perform
     * - geolocation from IP
     * - reverse location from lat,lon obtained from browser
     *
     * Promise get following status:
     * - resolved if at least one of the 2 succeed
     * - failed if both fail
     */
    update() {
        var self = this;
        var p = new Promise(function (resolve, reject) {

            //start with geolocation from public IP
            self.getGeoLocation().then(
                (res) => {
                    if (res.data.hasOwnProperty("query")) {
                      //parsing of web service returning json with all data
                      self.result.geo = res.data;
                    } else {
                      //expect fallback based on portal ws/1/ip?isp=true, parse XML
                      try {
                        var parser = new DOMParser();
                        var xmlDoc = parser.parseFromString(res.data, "text/xml");
                        self.result.geo = {
                          query: xmlDoc.getElementsByTagName("ip")[0].getAttribute("value"),
                          org: xmlDoc.getElementsByTagName("isp")[0].textContent,
                          isp: xmlDoc.getElementsByTagName("isp")[0].textContent,
                          zip: undefined,
                          city: undefined,
                          country: undefined
                        }

                      } catch(e) {
                        //too bad, we are not able to parse answer
                        console.error("webservice geolocation returned unknown answer: "+res.data);
                      }

                    }

                    return self.getCurrentPosition();
                },
                (err) => {
                    self.result.geo = undefined;
                    return self.getCurrentPosition();
                }
            ).then(
                (res) => {
                    self.result.lat = res.coords.latitude;
                    self.result.lon = res.coords.longitude;
                    self.getReverseGeoLocation(self.result.lat, self.result.lon, undefined).then(
                        (res) => {
                            self.result.reversegeo = res.data.address;
                            resolve(self.result);
                        },
                        (err) => {
                            resolve(self.result);
                        }
                    );
                }
                ,
                (err) => {
                    self.result.lat = undefined;
                    self.result.lon = undefined;
                    resolve(self.result);
                    //stop here, not georeverse if lat/lon not obtained
                }
            )
        });
        return p;
    }
}

LocationService.$inject = ['$rootScope', '$http', '$q', '$window'];




// WEBPACK FOOTER //
// ./src/equalone-ui/components/location/LocationService.js